// extracted by mini-css-extract-plugin
export default {"promptInput":"Prompt_promptInput__0M30d","promptButton":"Prompt_promptButton__a3pbs"};